import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionewaycab() {



const cardData = {
  keyword: " Pune to Mumbai One Way Cab  ",

"headingDescription": "SRS Cab Service offers Pune to Mumbai One Way Cab, providing a cost-effective, comfortable, and hassle-free travel solution without return charges. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth journey from Pune to Mumbai. Ideal for airport transfers, business trips, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and reliable one-way travel experience.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea. Travelers using SRS Cab Service from Pune often visit this monument for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for its scenic beauty and sunset views. Visitors using SRS Cab Service often relax here and enjoy the city’s skyline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for its historical and cultural significance."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station is known for its Victorian Gothic architecture. Visitors using SRS Cab Service often admire this UNESCO World Heritage Site."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of the most popular beaches in Mumbai. Travelers using SRS Cab Service often visit for street food, sunset views, and leisure time."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a famous temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often visit to seek blessings and spiritual peace."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered religious site located on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit this place for its spiritual and scenic appeal."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a popular shopping street in Mumbai. Visitors using SRS Cab Service often explore this area for shopping and local experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green space offering wildlife and trekking options. Travelers using SRS Cab Service often visit for nature and outdoor activities."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting key parts of Mumbai. Visitors using SRS Cab Service often experience this route for its engineering and scenic views."
  }
],



services: [
{
name: "Pune to Mumbai One Way Cab",
description: "Pune to Mumbai one way cab offers economical travel without return charges. Customers can book direct rides for airport and city travel. Professional drivers ensure safe expressway journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai taxi one way provides convenient travel for single-direction trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune Mumbai Cab One Way",
description: "Pune Mumbai cab one way offers direct transportation between cities. Customers can book cabs for business and personal travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Cab Pune to Mumbai Airport",
description: "One way cab Pune to Mumbai airport offers reliable airport transfer services. Customers can book cabs for timely drop to terminals. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with airport cab services."
},
{
name: "One Way Mumbai to Pune",
description: "One way Mumbai to Pune provides convenient return travel options. Customers can book cabs for direct journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Pune to Mumbai",
description: "One way Pune to Mumbai offers flexible travel for single-direction trips. Customers can book cabs easily without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mumbai One Way Innova Crysta Taxi Cab",
description: "Pune to Mumbai one way Innova Crysta taxi cab offers premium SUV travel for comfort. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and airport travel. Transparent pricing ensures value. Travel comfortably with Innova Crysta."
},
{
name: "Pune to Mumbai Airport One Way Cab",
description: "Pune to Mumbai airport one way cab provides convenient airport transfer services. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with airport cab services."
},
{
name: "Pune to Mumbai One Way Sedan Taxi Cab",
description: "Pune to Mumbai one way sedan taxi cab offers budget-friendly travel for individuals. Customers can book comfortable sedan vehicles. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with sedan cab services."
},
{
name: "One Way Cab Booking Pune to Mumbai",
description: "One way cab booking Pune to Mumbai offers quick and easy reservation options. Customers can book cabs online instantly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily online."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip provides convenient two-way travel options. Customers can book cabs for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab provides spacious and comfortable SUV travel. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Pune to Mumbai Taxi Services",
description: "Pune to Mumbai taxi services offer reliable transportation for daily and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "One Way Cab",
description: "One way cab offers economical travel for single-direction trips across cities. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mumbai Taxi Service One Way Cab Service",
description: "Pune to Mumbai taxi service one way cab service provides direct travel without return charges. Customers can book taxis for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai airport cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Cheapest Cab from Pune to Mumbai Airport",
description: "Cheapest cab from Pune to Mumbai airport offers budget-friendly travel options. Customers can book cabs at low prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap cab services."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai offers top-rated transportation for intercity travel. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Pune to Mumbai One Way SRS Cab Service",
description: "Pune to Mumbai one way SRS cab service provides reliable travel solutions for customers. Users can book cabs for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cab services."
},
{
name: "Pune to Mumbai One Way Ertiga Cab",
description: "Pune to Mumbai one way Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for direct journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab offers reliable transfer services for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune to Mumbai One Way Cab Service",
description: "Pune to Mumbai one way cab service offers direct travel without return charges. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cab services."
},
{
name: "Pune to Mumbai One Way Taxi Service",
description: "Pune to Mumbai one way taxi service provides convenient travel for single-direction trips. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services."
},
{
name: "Pune to Mumbai One Way Cab Booking",
description: "Pune to Mumbai one way cab booking offers instant reservation options. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily."
},
{
name: "Pune to Mumbai One Way Taxi Booking",
description: "Pune to Mumbai one way taxi booking provides quick booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your taxi easily."
},
{
name: "Pune to Mumbai One Way Cab Fare",
description: "Pune to Mumbai one way cab fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
}
],

tableData: [
["Pune to Mumbai One Way Cab","Pune to Mumbai Taxi One Way"],
["Pune Mumbai Cab One Way","One Way Cab Pune to Mumbai Airport"],
["One Way Mumbai to Pune","One Way Pune to Mumbai"],
["Pune to Mumbai One Way Innova Crysta Taxi Cab","Pune to Mumbai Airport One Way Cab"],
["Pune to Mumbai One Way Sedan Taxi Cab","One Way Cab Booking Pune to Mumbai"],
["Pune to Mumbai Cab Round Trip","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune to Mumbai Taxi Services"],
["One Way Cab","Pune to Mumbai Taxi Service One Way Cab Service"],
["Pune to Mumbai Airport Cab Fare","Cheapest Cab from Pune to Mumbai Airport"],
["Best Cab Service Pune to Mumbai","Pune to Mumbai One Way SRS Cab Service"],
["Pune to Mumbai One Way Ertiga Cab","Pune to Mumbai Airport Cab"],
["Pune to Mumbai One Way Cab Service","Pune to Mumbai One Way Taxi Service"],
["Pune to Mumbai One Way Cab Booking","Pune to Mumbai One Way Taxi Booking"],
["Pune to Mumbai One Way Cab Fare","One Way Cab Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable One Way Pune to Mumbai Cab",
    WhyChoosedescription: "SRS Cab Service offers budget-friendly Pune to Mumbai one way cab service where you pay only for one-side travel without return charges."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-experienced with the Mumbai-Pune Expressway, ensuring safe, fast, and smooth travel between Pune and Mumbai."
  },
  {
    WhyChooseheading: "24/7 One Way Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Mumbai one way cab bookings, suitable for airport drops, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles to ensure a comfortable one way journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Pune",
    WhyChoosedescription: "We offer pickup from homes, hotels, offices, and Pune Airport across all areas including Hinjewadi, Wakad, Baner, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Customers receive clear fare details including tolls and driver charges before booking, ensuring a hassle-free experience."
  },
  {
    WhyChooseheading: "Trusted One Way Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mumbai one way cab bookings due to punctual service, reliable drivers, and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Mumbai one way cab service?", answer: "Yes, SRS Cab Service offers reliable one way cab services from Pune to Mumbai." },
  { question: "What is the distance from Pune to Mumbai?", answer: "The distance between Pune and Mumbai is approximately 150 km and takes around 3 to 4 hours via expressway." },
  { question: "Is one way cab cheaper than round trip?", answer: "Yes, one way cab is more affordable as you only pay for one-side travel." },
  { question: "Is Pune to Mumbai one way cab available 24 hours?", answer: "Yes, our cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book one way cab online?", answer: "Yes, you can easily book Pune to Mumbai one way cab online or via phone." },
  { question: "Do you provide airport drop in Mumbai?", answer: "Yes, we provide Mumbai Airport drop services including T1 and T2 terminals." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from any location in Pune." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshpande",
    feedback:
      "Booked Pune to Mumbai one way cab. Very affordable and smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best one way cab service. On-time pickup and comfortable ride.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mumbai One Way Cab | SRS Cab Service",
  "description": "Book one-way cabs from Pune to Mumbai including airport transfers, Innova Crysta, Ertiga, Sedan, and luxury taxis. Affordable and reliable one-way cab service from Pune to Mumbai.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-mumbai-one-way-cab",
  "areaServed": ["Pune", "Mumbai", "Mumbai Airport", "Thane", "Kalyan", "Vashi"],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹",
  "serviceType": [
    "Pune to Mumbai One Way Cab",
    "Pune to Mumbai Taxi One Way",
    "One Way Cab Pune to Mumbai Airport",
    "Pune to Mumbai Airport Drop",
    "Innova Crysta Taxi Pune to Mumbai",
    "Ertiga Taxi Pune to Mumbai",
    "Sedan Taxi Pune to Mumbai",
    "Round Trip Cab Pune to Mumbai"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1420"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai One Way Cab | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book affordable one-way cabs from Pune to Mumbai. Choose Innova Crysta, Ertiga, or Sedan taxis for airport transfers and city travel. Best Pune to Mumbai cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionewaycab;